/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Text } from "src/components/Text";
import { style } from "./RestoreProgress.style";

import { Box } from "src/components/Box";
import { Icon } from "src/components/Icon";
import { Fragment, useState } from "react";
import { FormattedMessage } from "react-intl";
import { PanelList } from "src/components/PanelList";
import { Status, WebsiteRestoring } from "./VaultOverview";

import { ProgressBar } from "src/components/ProgressBar";
import { websiteProgressProgressBar } from "../migrations/MoveServerProgress/MigrationCard.style";
import { MigrationStatus } from "src/orchd-client";
import { getBackupDateTime } from "../websites/website/backups/WebsiteBackupCard";


interface Props {
  websitesRestoring: WebsiteRestoring[],
  statuses: Record<string,Status>,
  setWebsitesRestoring: React.Dispatch<React.SetStateAction<WebsiteRestoring[]>>
}

export const RestoreProgress = (props: Props) => {
  const { websitesRestoring, statuses, setWebsitesRestoring } = props;
  const [expanded, setExpanded] = useState(true);

  const panels = websitesRestoring.map(website => { return {
    content:
    <Box d="row" mt="sm" mb="md">
      <Box d="row" a="center">
        <Box w={11}>
          <Text size="sm" whiteSpace="nowrap">
            {website.domain} {statuses[website.id]?.lastLog && ' - ' + statuses[website.id]?.lastLog}
          </Text>
        </Box>
        <Box d="row" w={1} j="flex-end" a="center">
          {!statuses[website.id]?.isComplete && <Icon name="loading" />}
          {statuses[website.id]?.isComplete && <Icon name="check circle alt" color="success" />}
        </Box>
      </Box>
      <Box w={12} mb="xs">
        <Text size="sm">
          {getBackupDateTime(website.date)}
        </Text>
      </Box>
      <Box css={websiteProgressProgressBar(statuses[website.id]?.isComplete ? MigrationStatus.complete : MigrationStatus.inProgress)}>
        <ProgressBar size="sm" percentageComplete={statuses[website.id]?.percentage} />
      </Box>
    </Box>
  }});

  const count = websitesRestoring.filter(entry => !statuses[entry.id]?.isComplete).length;

  return (
    <div
    data-qa="restoreProgress"
    css={style.restoreContainer(false)}
  >

      <Box data-qa="uploaderHeader" css={style.restoreProgressHeader} p="lg" onClick={() => setExpanded(!expanded)}>
        <Box w="auto" a="center">
          <Icon name={expanded ? 'chevron down' : 'chevron up'} color="light" marginRight="lg" />

            {count > 0 ? (
            <Fragment>
              <Icon name="loading" color="light" marginRight="sm" />

              <Text size="sm" color="light">
                <FormattedMessage
                  id="backups.vault.progress.restoring"
                  defaultMessage="Restoring {count} of {total}"
                  values={{ count, total: websitesRestoring.length }}
                />
              </Text>
            </Fragment>
            ) : (
            <Fragment>
              <Text size="sm" color="light">
                <FormattedMessage id="backups.vault.progress.restore_complete" defaultMessage="Restore complete" />
              </Text>
            </Fragment>
            )}



        </Box>

        {count === 0 && <Icon
            data-qa="clearUploader"
            name="close"
            color="light"
            onClick={() => setWebsitesRestoring([])}
        />}
      </Box>

      <Box data-qa="uploaderBody" h={expanded ? 'auto' : '0'}>
        <PanelList

          name="uploadingFiles"
          scrollAt={5}
          panels={panels}
        />
      </Box>

    </div>
  );
}
